// extracted by mini-css-extract-plugin
module.exports = {"general-conditions":"general-conditions_general-conditions__1QSzM","logo-header":"general-conditions_logo-header__1k4ns","container":"general-conditions_container__1q3Ja"};